import {
  PUSHER_EVENTS,
  generatePusherPrivateChannelName
} from '@linearb/linjs-common';
import { getRepositories } from 'state/callers';
import store from 'state/store/configureStore';

const addRepositoriesCallback = data => {
  getRepositories()(store.dispatch);
};

const eventNameToCallback = {
  [PUSHER_EVENTS.ADD_REPOSITORIES]: addRepositoriesCallback
};

export const subscribeToEvent = eventName => {
  const { organization } = store.getState();

  if (!window.pusher) {
    window.TrackJS &&
      window.TrackJS.console.error(
        `Pusher client not found, user from org ${organization.id}`
      );
    return;
  }

  const channelName = generatePusherPrivateChannelName(organization.id);
  const channel = window.pusher.channel(channelName);
  const callback = eventNameToCallback[eventName];
  channel.bind(eventName, callback);
};
